import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { getValueIf } from '../../util/getValueIf.js';

var _excluded = ["width", "contentAlignment", "maxLines", "onClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultVariant = 'basic.neutral-1';
var defaultWidth = 'content-fit';
var defaultProps = {
  variant: defaultVariant,
  width: defaultWidth,
  maxLines: 1
};
function getHierarchy(type) {
  if (type.startsWith('primary')) return 'primary';
  if (type.startsWith('secondary')) return 'secondary';
  if (type.startsWith('tertiary')) return 'tertiary';
  return 'basic';
}
var mappedTokens = {
  'primary.interactive': {
    background: 'product.primary',
    text: 'base.inverted'
  },
  'primary.error': {
    background: 'feedback.negative',
    text: 'base.inverted'
  },
  'primary.price': {
    background: 'product.price',
    text: 'base.inverted'
  },
  'primary.positive': {
    background: 'feedback.positive',
    text: 'base.inverted'
  },
  'primary.urgency': {
    background: 'feedback.urgent',
    text: 'base.inverted'
  },
  'primary.intense': {
    background: 'feedback.negative',
    text: 'base.inverted'
  },
  'primary.notice': {
    background: 'feedback.notice',
    text: 'base.inverted'
  },
  'primary.neutral-1': {
    background: 'feedback.generic',
    text: 'feedback.on.generic'
  },
  'primary.neutral-2': {
    background: 'feedback.generic',
    text: 'feedback.on.generic'
  },
  'primary.family': {
    background: 'product.family',
    text: 'base.inverted'
  },
  'primary.rating-hotel': {
    background: 'product.rating-hotels',
    text: 'base.inverted'
  },
  'primary.rating-nha': {
    background: 'product.rating-homes',
    text: 'base.inverted'
  },
  'primary.dayuse': {
    background: 'product.day-use',
    text: 'base.inverted'
  },
  'secondary.interactive': {
    background: 'product.primary.subtle',
    text: 'product.primary'
  },
  'secondary.price': {
    background: 'product.price.subtle',
    text: 'product.price'
  },
  'secondary.error': {
    background: 'feedback.negative.subtle',
    text: 'feedback.negative'
  },
  'secondary.positive': {
    background: 'feedback.positive.subtle',
    text: 'feedback.on.positive.subtle'
  },
  'secondary.urgency': {
    background: 'feedback.urgent.subtle',
    text: 'feedback.urgent'
  },
  'secondary.intense': {
    background: 'feedback.negative.subtle',
    text: 'feedback.on.negative.subtle'
  },
  'secondary.notice': {
    background: 'feedback.notice.subtle',
    text: 'feedback.notice'
  },
  'secondary.neutral-1': {
    background: 'feedback.generic.subtle',
    text: 'feedback.on.generic.subtle'
  },
  'secondary.neutral-2': {
    background: 'feedback.generic.subtle',
    text: 'feedback.on.generic.subtle'
  },
  'secondary.family': {
    background: 'product.family.subtle',
    text: 'product.on.family.subtle'
  },
  'secondary.rating-hotel': {
    background: 'product.rating-hotels.subtle',
    text: 'product.rating-hotels'
  },
  'secondary.rating-nha': {
    background: 'product.rating-homes.subtle',
    text: 'product.rating-homes'
  },
  'secondary.dayuse': {
    background: 'product.day-use.subtle',
    text: 'product.day-use'
  },
  'tertiary.interactive': {
    border: 'product.primary.strong',
    text: 'product.primary'
  },
  'tertiary.price': {
    border: 'product.price.strong',
    text: 'product.price'
  },
  'tertiary.error': {
    border: 'feedback.negative.strong',
    text: 'feedback.negative'
  },
  'tertiary.positive': {
    border: 'feedback.positive.strong',
    text: 'feedback.on.positive.subtle'
  },
  'tertiary.urgency': {
    border: 'feedback.urgent.strong',
    text: 'feedback.urgent'
  },
  'tertiary.intense': {
    border: 'feedback.negative.strong',
    text: 'feedback.negative'
  },
  'tertiary.notice': {
    border: 'feedback.notice.strong',
    text: 'feedback.notice'
  },
  'tertiary.neutral-1': {
    border: 'feedback.generic',
    text: 'feedback.generic'
  },
  'tertiary.neutral-2': {
    border: 'feedback.generic',
    text: 'feedback.generic'
  },
  'tertiary.family': {
    border: 'product.family.strong',
    text: 'product.on.family.subtle'
  },
  'tertiary.rating-hotel': {
    border: 'product.rating-hotels.strong',
    text: 'product.rating-hotels'
  },
  'tertiary.rating-nha': {
    border: 'product.rating-homes.strong',
    text: 'product.rating-homes'
  },
  'tertiary.dayuse': {
    border: 'product.day-use.strong',
    text: 'product.day-use'
  },
  'basic.interactive': {
    text: 'product.primary'
  },
  'basic.price': {
    text: 'product.price'
  },
  'basic.error': {
    text: 'feedback.negative'
  },
  'basic.positive': {
    text: 'feedback.positive'
  },
  'basic.urgency': {
    text: 'feedback.urgent'
  },
  'basic.intense': {
    text: 'feedback.negative'
  },
  'basic.notice': {
    text: 'feedback.notice'
  },
  'basic.neutral-1': {
    text: 'feedback.generic'
  },
  'basic.neutral-2': {
    text: 'feedback.generic'
  },
  'basic.family': {
    text: 'product.on.family.subtle'
  },
  'basic.rating-hotel': {
    text: 'product.rating-hotels'
  },
  'basic.rating-nha': {
    text: 'product.rating-homes'
  },
  'basic.dayuse': {
    text: 'product.day-use'
  }
};
var contentAlignmentMapping = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end'
};
var mapContentAlignment = function mapContentAlignment(contentAlignment) {
  return contentAlignmentMapping[contentAlignment];
};
var getInteractive = function getInteractive(badgeHierarchy) {
  if (badgeHierarchy === 'secondary') return 'deprecated.secondary.interactive';
  if (badgeHierarchy === 'tertiary') return 'base.subtle';
  return 'product.primary';
};
var containerPropsMapper = function containerPropsMapper(props, hierarchy, tokens) {
  var iconOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var width = props.width,
    _props$contentAlignme = props.contentAlignment,
    contentAlignment = _props$contentAlignme === void 0 ? 'center' : _props$contentAlignme,
    _props$maxLines = props.maxLines,
    maxLines = _props$maxLines === void 0 ? 1 : _props$maxLines,
    onClick = props.onClick,
    rest = _objectWithoutProperties(props, _excluded);
  var background = tokens.background,
    border = tokens.border;
  var px = iconOnly ? '4' : '8';
  var isBasic = hierarchy === 'basic';
  var isTertiary = hierarchy === 'tertiary';
  var isParentFit = width === 'parent-fit';
  var isSingleLine = maxLines === 1;
  var isMultipleLines = maxLines >= 2;
  var justifyContent = mapContentAlignment(contentAlignment);
  return _objectSpread(_objectSpread(_objectSpread({}, rest), {}, {
    onClick: onClick,
    as: getValueIf(!!(onClick && !iconOnly), 'button'),
    interactive: getValueIf(iconOnly && !onClick, isBasic ? 'product.primary' : getInteractive(hierarchy)),
    display: 'inline-flex',
    alignSelf: 'flex-start',
    flexDirection: 'row',
    textAlign: 'start',
    p: '0',
    width: getValueIf(isParentFit, '100%'),
    alignItems: isMultipleLines ? 'flex-start' : 'center',
    justifyContent: justifyContent
  }, isTertiary && {
    borderStyle: 'solid',
    borderWidth: '1',
    borderColor: border
  }), !isBasic && {
    backgroundColor: background,
    borderRadius: '2',
    height: getValueIf(isSingleLine, '22px'),
    px: px,
    py: '4'
  });
};
var typographyPropsMapper = function typographyPropsMapper(props, hierarchy, tokens) {
  var _ref, _props$textAlign;
  return {
    variant: 'caption-default',
    tag: 'span',
    textColor: tokens.text,
    textAlign: (_ref = (_props$textAlign = props.textAlign) !== null && _props$textAlign !== void 0 ? _props$textAlign : props.contentAlignment) !== null && _ref !== void 0 ? _ref : hierarchy === 'basic' ? undefined : 'center',
    lineClamp: props.maxLines
  };
};

export { containerPropsMapper, defaultProps, getHierarchy, mappedTokens, typographyPropsMapper };
//# sourceMappingURL=Badge.mappers.js.map
